import { cva } from "../../../node_modules/.pnpm/class-variance-authority@0.7.1/node_modules/class-variance-authority/dist/index.js";
const textareaVariants = cva(null, {
  variants: {
    size: {
      sm: "min-h-18",
      default: "min-h-21",
      lg: "min-h-24"
    }
  },
  defaultVariants: {
    size: "default"
  }
});
export {
  textareaVariants
};
//# sourceMappingURL=variants.js.map
